import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ExpandedPanelStateService {
  private expandedPanelExpandedSubject = new BehaviorSubject<boolean>(false);
  expandedPanelExpanded$ = this.expandedPanelExpandedSubject.asObservable();

  setExpandedPanelExpanded(expanded: boolean): void {
    this.expandedPanelExpandedSubject.next(expanded);
  }

  getExpandedPanelState(): boolean {
    return this.expandedPanelExpandedSubject.value;
  }
}
